import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { AuthSelector, CoreState } from "@obg/ngx.core";
import { Observable } from "rxjs";
import { throttleTime } from "rxjs/operators";

@Component({
	selector: "obg-session-timer-container",
	templateUrl: "./session-timer.container.html",
	styleUrls: ["./session-timer.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SessionTimerContainer implements OnInit {
	@HostBinding("attr.test-id") testId = "obg-session-timer-container";

	@Input() timerText = "timer.session.text";

	sessionElapsedSeconds$: Observable<number | undefined> | undefined;

	constructor(private store: Store<CoreState>) {}

	ngOnInit() {
		this.initSessionElapsedSeconds$();
	}

	private initSessionElapsedSeconds$(): Observable<number | undefined> {
		return (this.sessionElapsedSeconds$ = this.store
			.select(AuthSelector.getSessionElapsedTimeInMillis)
			.pipe(throttleTime(100)));
	}
}
